export function formatEuro(value) {
  return `€ ${Intl.NumberFormat('it-IT', {
    maximumFractionDigits: 2
  }).format(value)}`;
}
export function formatEuroRange(minValue, maxValue) {
  let precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  const localizedMinValue = Intl.NumberFormat('it-IT', {
    maximumFractionDigits: precision
  }).format(minValue ?? 0);
  const localizedMaxValue = Intl.NumberFormat('it-IT', {
    maximumFractionDigits: precision
  }).format(maxValue ?? 0);
  if (minValue === undefined && maxValue === undefined) {
    return undefined;
  }
  if (minValue !== undefined && maxValue === undefined) {
    return `min. ${localizedMinValue} €`;
  }
  if (minValue === undefined && maxValue !== undefined) {
    return `max. ${localizedMaxValue} €`;
  }
  return `${localizedMinValue} € - ${localizedMaxValue} €`;
}